import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import SiteTemplate from './SiteTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';

SiteManageDialog.propTypes = {
  site: PropTypes.object.isRequired
};

export default function SiteManageDialog(props) {
  const { site } = props;

  if (site.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-lg">
      <CloseDialogButton onClick={props.onClose} />
      <div className="px-6 pt-16 pb-6">
        <SiteTemplate
          site={site}
          onClose={props.onClose}
        />
      </div>
    </DialogTemplate>
  );
};
